import React from "react";
import ProvedorAutenticacaoJwt from "@auth/services/jwt/ProvedorAutenticacaoJwt";
import { FuseAuthProviderType } from "@fuse/core/FuseAuthProvider/types/FuseAuthTypes";
import FuseAuthProvider from "@fuse/core/FuseAuthProvider";
import FuseAuthorization from "@fuse/core/FuseAuthorization";
import { User } from "@auth/user";
import { ConfiguracaoSistemaProvider } from "@/contexts/ConfiguracaoSistemaContext";
import UsertourIntegration from "@/services/usertour/UsertourIntegration";

/**
 * The Authentication providers.
 */
const authProviders: FuseAuthProviderType[] = [
	{
		name: "jwt",
		Provider: ProvedorAutenticacaoJwt,
	},
];

type AuthenticationProps = {
	children: React.ReactNode;
};

function Authentication(props: Readonly<AuthenticationProps>) {
	const { children } = props;

	return (
		<FuseAuthProvider providers={authProviders}>
			{(authState) => {
				const userRole = authState?.user?.permissoes as User["permissoes"];
				return (
					<ConfiguracaoSistemaProvider habilitado={authState?.isAuthenticated === true}>
						<UsertourIntegration />
						<FuseAuthorization userRole={userRole}>{children}</FuseAuthorization>
					</ConfiguracaoSistemaProvider>
				);
			}}
		</FuseAuthProvider>
	);
}

export default Authentication;
